import { Driver } from "./driver";
import { Rider } from "./rider";

export enum BookingStatuses {
    Confirmed = "confirmed",
    Completed = "completed",
    Refunded = "refunded",
    Canceled = "canceled",
    SearchingDrivers = "searchingDrivers",
    PendingDriverToChooseTime = "pendingDriverToChooseTime",
    Accepted = "accepted",
    Arrived = "arrived",
    InTransit = "inTransit",
    EndIntend = "endIntend",
    WaitForPayment = "waitForPayment",
    PaymentFailed = "paymentFailed",
}

export interface Booking {
    _id?: string;
    status?: string;

    rider?: Rider;
    driver?: any;
    potentialDrivers?: [
        {
            location?: {
                type?: string;
                coordinates?: number[];
            };
            driver?: Driver;
            status?: string;
        }
    ];
    totalAvailableDrivers?: number;

    startLoc?: {
        address?: string;
        geo?: {
            type?: string;
            coordinates?: number[];
        };
    };
    extraInfo?: string;
    endLoc?: {
        address?: string;
        geo?: {
            type?: string;
            coordinates?: number[];
        };
    };

    optionsInfo?: string;
    prices?: {
        ride?: number;
        rideFull?: number;
        rideDriver?: number;

        tip?: number; // Bacșiș paid by the rider with the review, in bani
        commission?: number; // Comision: platform's cut of the ride fare, in bani
        bonus?: number; // Bonus: driver's share of the tip, in bani

        total?: number; // Boost + ride total cost of the ride WITH discount applied
        totalFull?: number; // Boost + ride total cost of the ride WITHOUT any discount applied
        discount: number; // The discount value applied

        correction: number; // The difference between total and estimation (negative or positive)
        estimation: number; // Boost + ride paid by the rider at the start of the ride with discount applied
        estimationRide: number; // ride paid by the rider at the start of the ride with discount applied
        estimationBoost: number; // Boost paid by the rider at the start of the ride with discount applied
    };
    payment?: {
        card?: any;
        userPromoCode?: any;
        paidByCash?: boolean;
        boost?: {
            status?: string;
            maxWaitTs?: string;
            transactionLog?: any;
        };
        ride?: {
            status?: string;
            maxWaitTs?: string;
            transactionLog?: any;
        };
        correction?: {
            status?: string;
            maxWaitTs?: string;
            transactionLog?: any;
        };
        estimationBoost?: {
            status?: string;
            maxWaitTs?: string;
            transactionLog?: any;
        };
        estimationRide?: {
            status?: string;
            maxWaitTs?: string;
            transactionLog?: any;
        };
    };

    numberOfBags?: number;
    numberOfPassengers?: number;

    updates?: any;

    adminNote?: string;
    completedBeforePaymentOk?: boolean;
    completedWithoutPayment?: boolean;

    createdTs?: Date;
}